var React = require('react');

function CheckMarker (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","stroke":"#F3336C","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M8 12.4286L10.5263 15L16 9","stroke":"#F3336C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckMarker.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckMarker;

CheckMarker.default = CheckMarker;
